/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResponseResult } from './ResponseResult';
import {
    ResponseResultFromJSON,
    ResponseResultFromJSONTyped,
    ResponseResultToJSON,
    ResponseResultToJSONTyped,
} from './ResponseResult';
import type { OrderAlertList } from './OrderAlertList';
import {
    OrderAlertListFromJSON,
    OrderAlertListFromJSONTyped,
    OrderAlertListToJSON,
    OrderAlertListToJSONTyped,
} from './OrderAlertList';

/**
 * 
 * @export
 * @interface ResponseOrderAlert
 */
export interface ResponseOrderAlert {
    /**
     * 
     * @type {ResponseResult}
     * @memberof ResponseOrderAlert
     */
    result: ResponseResult;
    /**
     * 
     * @type {OrderAlertList}
     * @memberof ResponseOrderAlert
     */
    data: OrderAlertList;
}

/**
 * Check if a given object implements the ResponseOrderAlert interface.
 */
export function instanceOfResponseOrderAlert(value: object): value is ResponseOrderAlert {
    if (!('result' in value) || value['result'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ResponseOrderAlertFromJSON(json: any): ResponseOrderAlert {
    return ResponseOrderAlertFromJSONTyped(json, false);
}

export function ResponseOrderAlertFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseOrderAlert {
    if (json == null) {
        return json;
    }
    return {
        
        'result': ResponseResultFromJSON(json['result']),
        'data': OrderAlertListFromJSON(json['data']),
    };
}

export function ResponseOrderAlertToJSON(json: any): ResponseOrderAlert {
    return ResponseOrderAlertToJSONTyped(json, false);
}

export function ResponseOrderAlertToJSONTyped(value?: ResponseOrderAlert | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'result': ResponseResultToJSON(value['result']),
        'data': OrderAlertListToJSON(value['data']),
    };
}

